import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../Buttons/Button";
import { approveOrder } from "../../store/actions/stocks/approveOrder";

function ApproveOrderModal({ open, onClose, order }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.stocks?.approvePending);
  const [executionPrice, setExecutionPrice] = useState("");
  const [smsAlertCscsFee, setSmsAlertCscsFee] = useState("");

  const isSell =
    (order?.side || order?.type || order?.order_type || "").toLowerCase() ===
    "sell";

  useEffect(() => {
    if (open) {
      setExecutionPrice(order?.price ?? order?.stock?.current_price ?? "");
      setSmsAlertCscsFee("");
    }
  }, [open, order]);

  const handleApprove = () => {
    dispatch(
      approveOrder({
        id: order?.id,
        data: {
          execution_price: Number(executionPrice),
          sms_alert_cscs_fee: Number(smsAlertCscsFee),
        },
        callback: onClose,
      })
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <h1 className="font-semibold text-2xl mb-1">
            Approve {isSell ? "Sell " : ""}Order
          </h1>
          <p className="text-sm mb-6 text-[#475467]">
            Enter the execution price and SMS alert / CSCS fee to approve this
            order.
          </p>

          <label className="text-sm font-[500]">Execution Price</label>
          <input
            type="number"
            value={executionPrice}
            onChange={(e) => setExecutionPrice(e.target.value)}
            placeholder="Enter execution price"
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-6 outline-none"
          />

          <label className="text-sm font-[500]">SMS Alert / CSCS Fee</label>
          <input
            type="number"
            value={smsAlertCscsFee}
            onChange={(e) => setSmsAlertCscsFee(e.target.value)}
            placeholder="Enter SMS alert / CSCS fee"
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-6 outline-none"
          />

          <div className="flex mt-2 w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              height="44px"
              borderColor="#D0D5DD"
              color="#344054"
              margin="0px 25px 0px 0px"
              onClick={onClose}
            />
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              children="Approve"
              width="100%"
              height="44px"
              loading={loading}
              padding="10px"
              color="#fff"
              disabled={executionPrice === "" || smsAlertCscsFee === ""}
              onClick={handleApprove}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ApproveOrderModal;
